var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-toast',{attrs:{"toast":_vm.toast},on:{"action":function($event){return _vm.ctl.runToastAction()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }